import { useState, useEffect, useContext } from 'react';

import { useParams } from "react-router-dom";
import axios from 'axios'
import useBreadcrumbs from 'use-react-router-breadcrumbs'
import { Breadcrumb } from 'react-bootstrap'
import { UserContext } from '../../../context/user-context';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FaImage, FaLink, FaChartLine, FaUser, FaTicketAlt } from 'react-icons/fa'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import CopyLinkButton from '../../../components/ui/copyLinkButton';
import EventSidebarLinks from '../../../components/events/sidebar-links';

import '../../attendees/attendees.css'
import './team.css'

const TooltipButton = ({ buttonText, tooltipText }) => {
  // Define the tooltip
  const renderTooltip = (props) => (
    <Tooltip id="copy-tooltip" {...props}>
      {tooltipText}
    </Tooltip>
  );
  return (
    <div className="d-flex justify-content-center">
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 400 }}
        overlay={renderTooltip}
      >
        <Button
          variant="transparent"
          className="text-white p-0"
        >
          {buttonText}
        </Button>
      </OverlayTrigger>
    </div>
  );
};

export default function EventTeam() {
  const breadcrumbs = useBreadcrumbs();
  const { userToken, user } = useContext(UserContext);
  const { event_id } = useParams();
  const [loading, setLoading] = useState(true);
  const [event, setEvent] = useState([]);
  const [team, setTeam] = useState(null);

  useEffect(() => {
    if (!user) {
      return
    }
    fetchEventTeam();
  }, []);

  const fetchEventTeam = async () => {
    try {
      const time = new Date().getTime();
      const eventResponse = await axios.get(process.env.REACT_APP_API_BASE_URL + `/wp-json/gnetwork/v1/events/${event_id}?timestamp=${time}`, {
        headers: {
          'Authorization': 'Basic ' + btoa(user.user_login + ":" + userToken),
          'Content-Type': 'application/json',
        }
      });
      setEvent(eventResponse.data.data);
      const teamResponse = await axios.get(process.env.REACT_APP_API_BASE_URL + `/wp-json/gnetwork/v1/events/${event_id}/team?timestamp=${time}`, {
        headers: {
          'Authorization': 'Basic ' + btoa(user.user_login + ":" + userToken),
          'Content-Type': 'application/json',
        }
      });
      // console.log('setTeam', teamResponse.data.team);
      setTeam(teamResponse.data.team);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching team:', error);
    }
  };

  return (
    <Container fluid className="p-relative">
      <EventSidebarLinks event={event}/>
      <Container className="event-stats-container py-3">
        {loading && (
          <p>Loading...</p>
        )}
        {<Breadcrumb>
          {breadcrumbs.map(({ breadcrumb, key, location, match }, index) => {
            breadcrumb = ((key === ('/events/' + event_id)) ? event?.post_title : breadcrumb);
            return (<Breadcrumb.Item key={index} href={key}>{breadcrumb}</Breadcrumb.Item>);
          })}
        </Breadcrumb>}
        <p>Data shown is from {event?.post_date} to today.</p>
        <section className="team-members">
          {(team && team != null) && (
            <>
              <h3 className="text-center mb-3">Hosted by</h3>
              <Row className="mb-3">
                <Col xs="auto" className="attendee-item_img-wrap">
                  <div style={{ width: '4rem' }}>
                    <FaImage />
                  </div>
                </Col>
                <Col className="attendee-item_details">
                  <FaLink />
                </Col>
                <Col className="d-flex justify-content-center align-items-center">
                  <FaChartLine /><TooltipButton buttonText="Visits" tooltipText="Visit is a link click"/>
                </Col>
                <Col className="d-flex justify-content-center align-items-center">
                  <FaUser /><TooltipButton buttonText="Assets" tooltipText="Asset is a new member"/>
                </Col>
                <Col className="d-flex justify-content-center align-items-center">
                  <FaTicketAlt /><TooltipButton buttonText="RSVPs" tooltipText="RSVP is a new event attendee"/>
                </Col>
              </Row>
              {Array.isArray(team.hosts) && team.hosts.length > 0 && (
                <>
                  {team.hosts.map((person, key) => {
                    let convertedCount = 0;
                    if (person.visits) {
                      convertedCount = person.visits.reduce((count, visit) => {
                        return count + (visit.converted === '1' ? 1 : 0);
                      }, 0);
                    }
                    const totalVisits = person.visits ? person.visits.length : 0;
                    const conversionPercentage = totalVisits > 0 ? ((convertedCount / totalVisits) * 100).toFixed(2) : 0;
                    return (
                      <Row key={key} className="align-items-center mb-3">
                        <Col xs="auto" className="attendee-item_img-wrap">
                          <img className="attendee-item_img" src={person?.profile_avatar} alt={person.first_name} loading="lazy"/>
                        </Col>
                        <Col className="attendee-item_details">
                          <h5 className="m-0">{person.first_name} {person.last_name}</h5>
                          <span className="d-block text-silver">{person.occupation}</span>
                          <CopyLinkButton text="Referral" url={person.referral_url}/>
                        </Col>
                        <Col className="d-flex justify-content-center align-items-center">
                          Total {totalVisits > 0 ? totalVisits : 0}<br/>
                          Converted {convertedCount}<br/>
                          {conversionPercentage}% Conversion 
                        </Col>
                        <Col className="d-flex justify-content-center align-items-center">
                          {person.assets}
                        </Col>
                        <Col className="d-flex justify-content-center align-items-center">
                          {person.rsvps}
                        </Col>
                      </Row>
                    );
                  })}
                </>
              )}
              {Array.isArray(team.promoters) && team.promoters.length > 0 && (
                <>
                  {team.promoters.map((person, key) => {
                    let convertedCount = 0;
                    if (person.visits) {
                      convertedCount = person.visits.reduce((count, visit) => {
                        return count + (visit.converted === '1' ? 1 : 0);
                      }, 0);
                    }
                    const totalVisits = person.visits ? person.visits.length : 0;
                    const conversionPercentage = totalVisits > 0 ? ((convertedCount / totalVisits) * 100).toFixed(2) : 0;
                    return (
                      <Row key={key} className="mb-3">
                        <Col xs="auto" className="attendee-item_img-wrap">
                          <img className="attendee-item_img" src={person?.profile_avatar} alt={person.first_name} loading="lazy"/>
                        </Col>
                        <Col className="attendee-item_details">
                          <h5 className="m-0">{person.first_name} {person.last_name}</h5>
                          <span className="d-block text-silver">{person.occupation}</span>
                          <CopyLinkButton text="Referral" url={person.referral_url}/>
                        </Col>
                        <Col className="d-flex justify-content-center align-items-center">
                          Total {totalVisits > 0 ? totalVisits : 0}<br/>
                          Converted {convertedCount}<br/>
                          {conversionPercentage}% Conversion 
                        </Col>
                        <Col className="d-flex justify-content-center align-items-center">
                          {person.assets}
                        </Col>
                        <Col className="d-flex justify-content-center align-items-center">
                          {person.rsvps}
                        </Col>
                      </Row>
                    );
                  })}
                </>
              )}
              {Array.isArray(team.media) && team.media.length > 0 && (
                <>
                  <h3 className="text-center mb-3">Captured by</h3>
                  {team.media.map((person, key) => {
                    return (
                      <Row key={key} className="mb-3">
                        <Col xs="auto" className="attendee-item_img-wrap">
                          <img className="attendee-item_img" src={person?.profile_avatar} alt={person.first_name} loading="lazy"/>
                        </Col>
                        <Col className="attendee-item_details">
                          <h5 className="m-0">{person.first_name} {person.last_name}</h5>
                          <span className="d-block text-silver">{person.occupation}</span>
                          {person.referral_url && (
                            <CopyLinkButton text="Referral" url={person.referral_url}/>
                          )}
                        </Col>
                      </Row>
                    );
                  })}
                </>
              )}
            </>
          )}
        </section>
      </Container>
    </Container>
  );
}
